module.exports = __webpack_public_path__ + "static/media/card-index-middle-2.6c9ef4e4.jpg";